import { render, staticRenderFns } from "./SelectTreatmentContractModal.vue?vue&type=template&id=5011f9b7&"
import script from "./SelectTreatmentContractModal.vue?vue&type=script&lang=js&"
export * from "./SelectTreatmentContractModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports